import React from 'react'
import { CunyAdminRoutes } from "../routing/routes.component"

export const CunyAdmin = () => <CunyAdminRoutes />